(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/onetrust/assets/javascripts/onetrust.js') >= 0) return;  svs.modules.push('/components/components/onetrust/assets/javascripts/onetrust.js');

'use strict';

(function () {
  if (!svs.components.onetrust.data.enabled) {
    return;
  }
  var logger = svs.core.log.getLogger('component:onetrust');

  window.OptanonWrapper = function () {
    if (!window.OneTrust.IsAlertBoxClosed() && svs.components.onetrust.data.att === true) {
      if (location.pathname.startsWith('/logga-in/poker')) {
        window.OneTrust.AllowAll();
      }
    } else if (!window.OneTrust.IsAlertBoxClosed() && svs.components.onetrust.data.att === false) {
      if (location.pathname.startsWith('/logga-in/poker')) {
        window.OneTrust.RejectAll();
      }
    }
    window.OneTrust.OnConsentChanged(function (consent) {
      var optanonPerformance = false;
      var optanonPersonalization = false;
      try {
        optanonPerformance = consent.detail.indexOf('C0002') !== -1;
        optanonPersonalization = consent.detail.indexOf('C0003') !== -1;
      } catch (e) {
        logger.warn('Unable to parse Onetrust cookie "OptanonConsent"');
      }
      var analyticsConsent = new svs.components.analytics.customEvents.AnalyticsConsentChanged(optanonPerformance);
      analyticsConsent.track();
      var personalizedConsent = new svs.components.analytics.customEvents.PersonalizedConsentChanged(optanonPersonalization);
      personalizedConsent.track();
      setTimeout(function () {
        location.reload();
      }, 500);
    });
  };
})();

 })(window);